export const TABLE_MODAL_PAGINATION_PAGE_BUFFER_SIZE = 3
